import { combineReducers } from "redux";

import RolePermissionReducer from "./RolePermissionReducer";

const IndexReducer = combineReducers({
  RolePermissionReducer,
});

export default IndexReducer;
